<script setup lang="ts">
  import { IconError } from '@gat-ship/icons'
  import { notificationSink } from '@gat-ship/error-handling'
  import { computed } from 'vue'
  import { Button } from '@gat-ship/vue-components'
  import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle
  } from '@gat-ship/vue-components'

  const dialog = computed(() => notificationSink.state.dialog)
  const isOpen = computed(() => dialog.value !== null)

  function refreshPage() {
    window.location.reload()
  }
</script>

<template>
  <AlertDialog :open="isOpen">
    <AlertDialogContent>
      <AlertDialogHeader>
        <div class="flex w-full items-center gap-2">
          <div class="flex h-10 w-10 items-center justify-center rounded-md">
            <IconError :stroke-width="1.5" class="text-destructive" />
          </div>
          <AlertDialogTitle class="text-lg font-semibold leading-none">
            {{ dialog?.title }}
          </AlertDialogTitle>
        </div>
        <AlertDialogDescription class="text-sm leading-none">
          {{ dialog?.message }}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <!--
        The sink only opens a dialog for `statusCode >= 500` and always sets
        `forceRefresh: true`, so there is no non-refresh branch here. If that
        routing rule ever gains a recoverable-5xx exception, reintroduce a
        v-else block with a plain Close button.
      -->
      <AlertDialogFooter v-if="dialog">
        <div class="flex grow items-center gap-4">
          <div class="text-muted-foreground text-sm">
            You will need to refresh the page to continue.
          </div>
          <Button class="ml-auto" @click="refreshPage()"> Refresh Page </Button>
        </div>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
